// extracted by mini-css-extract-plugin
module.exports = {"form":"postForm_form__ROHpt","input":"postForm_input__2Ob83","postBtn":"postForm_postBtn__3MGfk"};